import { Selector } from '@ngxs/store';
import { HelpState, HelpStateModel } from '../help.state';

export class HelpSelectors {
  @Selector([HelpState])
  static getRedirectUri(state: HelpStateModel): string {
    const redirectUri = state?.redirectUri;
    return redirectUri;
  }
}
